<script>
  import PaginationLabel from "./PaginationLabel.svelte";
  import Range from "./Range.svelte";
</script>

<div id="reports-search-pagination">
  <PaginationLabel />
  <Range />
</div>

<style>
  #reports-search-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 85px;
  }
  @media screen and (max-width: 980px) {
    #reports-search-pagination {
      margin-top: 0;
    }
  }
</style>
